<script>
import BasePopup from '@/components/BasePopup.vue';
import UserDetailTileField from '@/components/user/UserDetailTileField.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'AdminUserDetailPopup',
  components: { BasePopup, UserDetailTileField, BaseButton },
  data() {
    return {
      value: null,
    };
  },
  props: {
    config: Object,
  },
  computed: {
    fieldConfig() {
      return {
        accountBalance: {
          name: 'accountBalance',
          title: 'Сумма',
          value: this.value,
          displayValue: '0',
          emptyValue: '0',
          displayView: 'horizontal',
          editView: 'horizontal',
          changeType: 'input',
          change: (value) => { this.value = value; },
          emit: () => { this.$emit('update', { accountBalance: +this.config.currentValue + (+this.value * 100) }); },
          buttonLabel: 'Пополнить',
        },
      };
    },
  },
};
</script>

<template lang="pug">
BasePopup.b-admin-user-detail-popup(v-if="config" @close="$emit('close')")
  ._container
    ._header {{ config.label }}
    UserDetailTileField._field(:field="fieldConfig[config.fieldName]" :isEditMode="true" @change="fieldConfig[config.fieldName].change($event)")
    BaseButton._button(@click="fieldConfig[config.fieldName].emit()" blue md) {{ fieldConfig[config.fieldName].buttonLabel }}
</template>

<style scoped lang="scss">
.admin-user-detail-popup {
  &__container {
    width: 537px;
  }

  &__header {
    padding-bottom: 25px;
    border-bottom: 1px solid rgba(235, 239, 242, 1);
    color: rgb(35, 34, 38);
    font-family: Geometria, sans-serif;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
  }

  &__field {
    padding-top: 40px;
    padding-bottom: 29px;
  }
}
</style>
